module.exports = __webpack_public_path__ + "static/media/8.44108e6b.jpeg";